import React from 'react';
import { Share2, X } from 'lucide-react';

interface MarketingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onViewPage: () => void;
}

const MarketingModal = ({ isOpen, onClose, onViewPage }: MarketingModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 max-w-lg w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Partilhe as suas Reviews</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        <div className="space-y-4">
          <div className="flex items-center justify-center p-6 bg-gray-50 rounded-lg">
            <Share2 className="w-16 h-16 text-secondary" />
          </div>

          <div className="text-center space-y-3">
            <h3 className="text-lg font-medium">Aumente a Confiança dos seus Clientes</h3>
            <p className="text-gray-600">
              Partilhe a sua página de avaliações para mostrar a satisfação dos seus clientes. 
              É uma excelente forma de:
            </p>
          </div>

          <ul className="space-y-2 text-gray-600">
            <li className="flex items-center">
              <span className="w-2 h-2 bg-secondary rounded-full mr-2"></span>
              Aumentar a credibilidade do seu negócio
            </li>
            <li className="flex items-center">
              <span className="w-2 h-2 bg-secondary rounded-full mr-2"></span>
              Destacar-se da concorrência
            </li>
            <li className="flex items-center">
              <span className="w-2 h-2 bg-secondary rounded-full mr-2"></span>
              Conquistar novos clientes através de recomendações
            </li>
            <li className="flex items-center">
              <span className="w-2 h-2 bg-secondary rounded-full mr-2"></span>
              Melhorar sua presença online
            </li>
          </ul>

          <div className="pt-4">
            <button
              onClick={onViewPage}
              className="w-full bg-white border-2 border-gray-200 text-gray-700 rounded-lg px-4 py-2.5 font-medium hover:bg-gray-50 transition-colors flex items-center justify-center gap-2"
            >
              <Share2 className="w-5 h-5" />
              Ver Página de Reviews
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingModal;
